module.exports = `
<div class="item-row">
    <div class="item-img pull-left">
	    <a :href="item.Url" :title="item.Name">
	    	<div class="inner-wrap">
	    		<new-image :url="item.Color.Images[0].Url" :size="'_w150_h150'" :name="item.Name"></new-image>
	    	</div>
	    </a>
    </div>
    <div class="item-info pull-left mb-2">
	    <div>
	    	<a :href="item.Url" :title="item.Name" class="item-name d-block text-truncate mb-1">{{item.Name}}</a>
	    </div>
	    <div class="product-price">
			<span v-if="item.SellPrice !== item.OriginPrice || item.EventPrice >0" class="origin-price">NT$ {{item.OriginPrice.toLocaleString()}}</span>
	        <span class="sell-price">NT$ {{item.EventPrice >0 && item.EventPrice < item.SellPrice ?item.EventPrice.toLocaleString(): item.SellPrice.toLocaleString()}}</span>
	    </div>
	    <div class="mt-2">
	    	<select v-model="size" class="product-size-select form-control custom-ui">
	    	    <option value="SELECT A SIZE">SELECT A SIZE</option>
		    	<option v-for="(spec, index) in item.Color.Specs" :class="{'text-gray-200': spec.Stock === 0}" :disabled="spec.Stock === 0" :key="spec.ID" :value="item.CustomMarketID.replace('SZ_','SZ'+spec.Key)">{{spec.Name}} {{spec.Description}}</option>
	    	</select>
	    </div>
	</div>
</div>
`;
